<template>
  <footer class="c-footer">
    <div class="container">
      <div class="footer">
        <el-row :gutter="20">
          <el-col style="text-align:left" :xs="24" :sm="16">
            <el-row>
              <el-col class="mt-20-xs" :xs="24" :sm="12">
                <div class="mb-12">
                  <router-link
                    class="c-caption c-medium-text c-menu-footer"
                    to="/wap/hot-deal"
                  >
                    {{ $t("titleHotDeal") }}
                  </router-link>
                </div>
                <div class="mb-12">
                  <router-link
                    class="c-caption c-medium-text c-menu-footer"
                    to="/wap/top-course"
                    >{{ $t("titleTop10") }}</router-link
                  >
                </div>
                <div class="mb-12">
                  <router-link
                    class="c-caption c-medium-text c-menu-footer"
                    to="/wap/good-yard-area/1"
                    >{{ $t("titleMenuArea") }}</router-link
                  >
                </div>
                <!-- <div class="mb-12">
                  <router-link
                    class="c-caption c-medium-text c-white-text-important"
                    to="/wap"
                    >Stay&Play</router-link
                  >
                </div> -->
              </el-col>
              <el-col class="mt-20-xs" :xs="24" :sm="12">
                <!-- <div class="mb-12">
                  <router-link
                    class="c-caption c-medium-text c-white-text-important"
                    to="/wap/about"
                    >{{ $t("aboutUs") }}</router-link
                  >
                </div> -->
                <!-- <div class="mb-12">
                  <router-link
                    class="c-caption c-medium-text c-white-text-important"
                    to="/wap/contact-us"
                    >{{ $t("contact") }}</router-link
                  >
                </div> -->
                <div class="mb-12">
                  <!-- <router-link
                    class="c-caption c-medium-text c-white-text-important"
                    to="/"
                    >GolfNews</router-link
                  > -->
                  <!--                  <a-->
                  <!--                    href="https://www.vnewstoday.com/"-->
                  <!--                    class="c-caption c-medium-text c-white-text-important"-->
                  <!--                    >vNewsToday</a-->
                  <!--                  >-->
                </div>
                <div class="mb-12">
                  <!-- <router-link
                    class="c-caption c-medium-text c-white-text-important"
                    to="/"
                    >Vgs Travel</router-link
                  > -->
                  <!--                  <a-->
                  <!--                    href="https://vgstravel.com/"-->
                  <!--                    class="c-caption c-medium-text c-white-text-important"-->
                  <!--                    >Vgs Travel</a-->
                  <!--                  >-->
                </div>
                <div class="mb-12">
                  <!-- <router-link
                    class="c-caption c-medium-text c-white-text-important"
                    to="/"
                    >Vgs Tour</router-link
                  > -->
                  <!-- <a
                    href="https://vgstour.com/"
                    class="c-caption c-medium-text c-white-text-important"
                    >Vgs Tour</a
                  > -->
                </div>
              </el-col>
            </el-row>
          </el-col>

          <!--          <el-col class="mt-20-xs" :xs="24" :sm="8">-->
          <!--            <div class="align-right-sm-left">-->
          <!--              <div class="align-left">-->
          <!--                <router-link-->
          <!--                  class="c-caption c-medium-text c-white-text-important mb-12"-->
          <!--                  to="/wap"-->
          <!--                >-->
          <!--                  {{ $t("downloadApp") }}-->
          <!--                </router-link>-->
          <!--                <div class="platform-icon">-->
          <!--                  <a-->
          <!--                    class="mb-12"-->
          <!--                    :href="url.googlePlay"-->
          <!--                    target="_blank"-->
          <!--                    rel="noopener"-->
          <!--                  >-->
          <!--                    <img height="45px" width="auto" :src="googlePlay" alt="" />-->
          <!--                  </a>-->
          <!--                  <a-->
          <!--                    class="mb-12 ml-16-xs"-->
          <!--                    :href="url.appStore"-->
          <!--                    target="_blank"-->
          <!--                    rel="noopener"-->
          <!--                  >-->
          <!--                    <img height="45px" width="auto" :src="appStore" alt="" />-->
          <!--                  </a>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </el-col>-->
        </el-row>

        <hr class="c-divider-text divider" />

        <el-row class="show-sm mt-20" :gutter="20">
          <el-col :xs="24" :sm="12">
            <a
              class="c-caption c-medium-text c-menu-footer"
              :href="url.copyright"
              target="_blank"
              rel="noopener"
              >&copy; Copyright {{ year }}
              WBooking. All rights reserved
            </a>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="align-right-sm-left">
              <router-link to="/">
                <img
                  style="height: 50px; width: auto;"
                  :src="bg.logo_footer"
                  alt=""
                />
              </router-link>
            </div>
          </el-col>
        </el-row>

        <div class="show-xs">
          <div class="mt-16-xs">
            <router-link to="/">
              <img
                style="height: 50px; width: auto;"
                :src="bg.logo_footer"
                alt=""
              />
            </router-link>
          </div>
          <div class="mt-20 pointer-cursor">
            <a
              class="c-caption c-medium-text c-menu-footer"
              :href="url.copyright"
              target="_blank"
              >&copy; Copyright {{ year }}
              WBooking. All rights reserved
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import footerUrl from "@/constant/footer";
import { getBackGround } from "../../utils/wapAuth";

export default {
  name: "app-footer",
  data() {
    return {
      bg: getBackGround(),
      year: new Date().getFullYear()
    };
  },
  props: {
    url: {
      default: () => footerUrl
    },
    appStore: {
      default: require("@/assets/img/homepage/app_store.png")
    },
    googlePlay: {
      default: require("@/assets/img/homepage/google_play.png")
    },
    footerBanner: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
}
.mb-12 {
  margin-bottom: 12px;
}
.pointer-cursor {
  cursor: pointer;
}
.align-right-sm-left {
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.align-left {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.divider {
  height: 1px;
  width: 100%;
}
.mt-20 {
  margin-top: 20px;
}
.mt-20-xs {
  margin-top: 0px;
}
.show-sm {
  display: block;
}
.show-xs {
  display: none;
}
.platform-icon {
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .align-right-sm-left {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .mt-20-xs {
    margin-top: 20px;
  }
  .show-sm {
    display: none;
  }
  .show-xs {
    display: block;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .mt-16-xs {
    margin-top: 16px;
  }
  .platform-icon {
    display: flex;
    flex-direction: row;
    margin-bottom: 40px;
  }
  .ml-16-xs {
    margin-left: 16px;
  }
}
</style>
